import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding-top: 24px;\n  padding-bottom: 24px;\n  margin-top: -24px;\n  margin-bottom: -24px;\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { withOmitProps } from '../../helpers/elements';
import { isDefined } from '../../helpers/defined';
import { width } from '../../style/width';
var ItemsCarouselWrapper = styled.div.withConfig(withOmitProps(['fullWidth', 'width']))(_templateObject(), function (_ref) {
  var _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? true : _ref$fullWidth;
  return fullWidth && "\n    width: 100vw;\n    margin-left: 50%;\n    transform: translateX(-50%);\n  ";
}, function (_ref2) {
  var value = _ref2.width;
  return isDefined(value) && width(value);
});
export default ItemsCarouselWrapper;